export default __webpack_public_path__ + "static/9-9e9632b224c9f33e26833d6754c76bba.svg";